var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group:-2-objects"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.167,0l21.667,0c2.301,0 4.167,1.865 4.167,4.167l0,21.667c0,2.301 -1.865,4.167 -4.167,4.167l-21.667,0c-2.301,0 -4.167,-1.865 -4.167,-4.167l0,-21.667c0,-2.301 1.865,-4.167 4.167,-4.167Z",
    style: {
      fill: "#4e87ae",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group:-1-objects"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group:-2-objects1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path1",
    d: "M8.899,11.247l0,14.316l-4.454,0l0,-14.316l4.454,0Zm-2.226,-7.117c1.423,0 2.579,1.156 2.579,2.58c0,1.425 -1.156,2.581 -2.579,2.581c-1.429,0 -2.581,-1.156 -2.581,-2.581c0,-1.424 1.152,-2.58 2.581,-2.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path2",
    d: "M11.691,11.247l4.265,0l0,1.957l0.061,0c0.593,-1.125 2.045,-2.312 4.21,-2.312c4.505,0 5.338,2.964 5.338,6.82l0,7.852l-4.449,0l0,-6.962c0,-1.66 -0.028,-3.796 -2.312,-3.796c-2.315,0 -2.669,1.809 -2.669,3.677l0,7.081l-4.444,0l0,-14.316Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon_linkedin.95b5f81eba9690a33f965a2765638284.svg";
export { ForwardRef as ReactComponent };